import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { DictionaryRow } from '../../../../types/dictionary';

interface CreateDictionaryParams {
  companyId: string;
  fileName: string;
  rowCount: number;
  csvColumns: string[];
  rows: DictionaryRow[];
  uploadedByUid: string;
  uploadedByName: string;
  uploadedByIcon: string | null;
  // 代理ログイン中のアップロードか（#3343）。true のとき uploadedByName には「事務局」を渡す。
  isProxy?: boolean;
  // 代理操作した運営スタッフの UID（#3343）。代理でなければ undefined。
  operatorId?: string | null;
}

// 辞書本体（CSV データ）を作成する。パターン紐付けは createDictionaryMapping で別途登録する。
export const createDictionary = async (params: CreateDictionaryParams): Promise<string> => {
  const dictionariesRef = collection(db, 'dictionaries');
  const newDocRef = doc(dictionariesRef);

  const now = Timestamp.now();

  await setDoc(newDocRef, {
    company_id: params.companyId,
    file_name: params.fileName,
    row_count: params.rowCount,
    csv_columns: params.csvColumns,
    rows: params.rows,
    uploaded_by_uid: params.uploadedByUid,
    uploaded_by_name: params.uploadedByName,
    uploaded_by_icon: params.uploadedByIcon,
    // 代理操作の記録（#3343）。Firestore は undefined を保存できないため代理時のみ書く。
    ...(params.isProxy === true && {
      is_proxy: true,
      ...(params.operatorId && { operator_id: params.operatorId }),
    }),
    created_at: now,
    updated_at: now,
  });

  return newDocRef.id;
};
